import { forwardRef, useImperativeHandle } from 'react';
import './Filters.scss';
import FilterField from './FilterField';
import pictureClearAll from './clearAll.svg';

const Filters = forwardRef(function Filters(props, ref) {
  const selectedFilters = props?.report?.reportParams?.selectedFilters;

  useImperativeHandle(ref, () => {
    return {
      getFilter(report) {
        const newReport = report || props.report;
        if (newReport.fixFilter) {
          return (newReport.fixFilter === '#') ? '' : newReport.fixFilter;
        }

        const filterFields = Array.from(document.querySelectorAll('.reportFilter'))
          .filter((e) => e.value)
          .map((e) => {
            switch (e.type) {
              case 'date':
                const dateValue = new Date(e.value);
                const sqlDate = `CONVERT(DATETIME, '${dateValue.getFullYear()}-${dateValue.getMonth() + 1
                  }-${dateValue.getDate()}', 102)`;
                const sqlDate2359 = `CONVERT(DATETIME, '${dateValue.getFullYear()}-${dateValue.getMonth() + 1
                  }-${dateValue.getDate()} 23:59:59', 102)`;

                let result = e.dataset.sql.replace(/\?\(2359\)/g, sqlDate2359);
                result = result.replace(/\?/g, sqlDate);
                return result;

              default:
                return `(${e.dataset.sql.replace(/\?/g, e.value)})`;
            }
          });

        if (newReport.preFilter) {
          filterFields.push(newReport.preFilter);
        }
        return filterFields.join(' AND ');
      }
    }
  }, []);

  if (!selectedFilters) {
    return <></>;
  }

  const filters = selectedFilters.map((fieldName) => {
    const column = props.report.reportParams.columns.find(
      (col) => col.field === fieldName,
    );
    const filterField = {
      fieldName,
      filterType: column.type,
      options: column.options,
    };
    return filterField;
  });

  function clearAll() {
    Array.from(document.querySelectorAll('.reportFilter'))
      .filter((e) => e.value)
      .forEach(field => {
        field.value = '';
      })
  }

  return (
    <div ref={ref} className='filters'>
      <div className='filters-buttonArea' role='group'>
        <button type="button" className="btn btn-success" onClick={clearAll}>
          <img src={pictureClearAll} alt="Clear all filterfield" width="48px" height="48px" />
        </button>
      </div>
      <div className='filters-filterfields'>

        {filters.map((filterField) => (
          <FilterField
            key={`filter-${filterField.fieldName}`}
            fieldName={filterField.fieldName}
            filterType={filterField.filterType}
            options={filterField.options}
            languageElements={props.languageElements}
          />
        ))}

      </div>
    </div>
  );
});

export default Filters;
